// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__1Sbo9","rootSuccess":"CompleteLink_rootSuccess__3Jdj2","rootFailure":"CompleteLink_rootFailure__3ELLx","isDisabled":"CompleteLink_isDisabled__33Eh1"};